export default __webpack_public_path__ + "static/media/inn-add-product.9f4799de.png";